import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FnPaginationModule } from '../pagination/index';
import { FoundationModule } from '../../foundation.module';

import { FnTableComponent } from './fn-table.component';
import { FnTableSearchComponent } from './search/fn-table.search.component';
import { FnTranslateModule } from './../../i18n/index';

import { FnCoreModule } from '../../core/index';

export * from './fn-table.meta.data';
export * from './fn-table.config';

export * from './fn-table.component';
export * from './search/fn-table.search.component';

@NgModule({
	declarations: [FnTableComponent, FnTableSearchComponent],
	imports: [
		FormsModule,
		CommonModule,
		FnPaginationModule,
		FoundationModule,
		FnTranslateModule,
		FnCoreModule,
	],
	exports: [FnTableComponent, FnTableSearchComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FnTableModule {}
